import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/email-templates/')({
  beforeLoad: () => {
    throw redirect({ to: '/email-templates' })
  },
})
